// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/build/css/" + chunkId + "." + "61181fccc1de354d8deb" + ".css";
};